import { render, staticRenderFns } from "./DialogLandLordsRentProtection.vue?vue&type=template&id=591da6b6&"
import script from "./DialogLandLordsRentProtection.vue?vue&type=script&lang=js&"
export * from "./DialogLandLordsRentProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports